export enum MindyUsersPermissions {
    CreateUser = 'mindy:user:create',
    ReadUser = 'mindy:user:read',
    UpdateUser = 'mindy:user:update',
    DeleteUser = 'mindy:user:delete',
}

export enum MindyRolesPermissions {
    CreateRole = 'mindy:role:create',
    ReadRole = 'mindy:role:read',
    UpdateRole = 'mindy:role:update',
    DeleteRole = 'mindy:role:delete',
}

export enum MindyKnowledgePermissions {
    CreateKnowledge = 'mindy:knowledge:create',
    ReadKnowledge = 'mindy:knowledge:read',
    UpdateKnowledge = 'mindy:knowledge:update',
    DeleteKnowledge = 'mindy:knowledge:delete',
    AskKnowledge = 'mindy:knowledge:ask',
}

export enum MindyLogisticPermissions {
    AskLogistic = 'mindy:logistic:ask',
}
